module.exports = __webpack_public_path__ + "img/calcio.df5f456b.png";